import React from 'react';
import { SmallBodyText } from 'ui-toolkit';
import { Formik } from 'formik';
import { IHoaForm } from '../../../../../../types/order/hoa/IHoaDetailsTypes';
import { HoaSummaryItemForm, IHoaSummaryItemFormProps } from './HoaSummaryItemForm';
import { hoaFormValidator } from '../../../../../../validation/order/HoaFormValidator';

interface IEditHoaInlineProps extends IHoaSummaryItemFormProps {
  onReset: () => void;
  orderId: string;
}

export const EditHoaInline: React.FC<IEditHoaInlineProps> = ({ orderId, hoaDetails, onReset, onSave, onDelete }) => {
  let initialValues: IHoaForm =
    hoaDetails.length > 0 ? { orderId: orderId, hoas: hoaDetails } : { orderId: orderId, hoas: [] };

  return (
    <Formik
      initialValues={initialValues}
      validateOnMount={true}
      validationSchema={hoaFormValidator}
      enableReinitialize={true}
      onSubmit={() => {
        console.log('replace');
      }}
      onReset={onReset}
    >
      <div>
        <>{hoaDetails.length === 0 && <SmallBodyText intent={`faded`}>-</SmallBodyText>}</>
        <HoaSummaryItemForm hoaDetails={hoaDetails} onSave={onSave} onDelete={onDelete} />
      </div>
    </Formik>
  );
};
